module.exports = __webpack_public_path__ + "static/img/交件囉_300×300.229cc836.png";